type InitArgs<E> = {
	url: string;
	method: 'GET' | 'POST'; // expand as necessary
	experienceId: E; // expand as necessary
	product: 'jira'; // expand as necessary
};

export type JQLDebuggerType = {
	experienceId: 'jira-nl-to-jql-errors';
	body: {
		name: 'jirajqldebug';
		schema: {
			type: 'jirajqldebug';
			userQuery: string;
			userQueryError: string;
		};
	};
	response: {
		markdown: string;
		metadata: {
			aris: string[];
			responseState: 'SUCCESS'; // expand as necessary
			value: {
				originalJQL: string;
				correctedJQL: string;
				errors: string[];
				diff: {
					operation: 'CHANGE' | 'INSERT' | 'EQUAL' | 'DELETE';
					oldValue: string;
					newValue: string;
				}[];
			};
		};
		duration: number;
	};
};

type Registry = JQLDebuggerType;

type Options = {
	abortControllerSignal: AbortController['signal'];
};

export const createConvoAiEndpoint =
	<T extends Registry>(initArgs: InitArgs<T['experienceId']>) =>
	async (body: T['body'], options: Options): Promise<T['response']> => {
		const response = await fetch(initArgs.url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Product': initArgs.product,
				'X-Experience-Id': initArgs.experienceId,
			},
			body: JSON.stringify(body),
			signal: options.abortControllerSignal,
		});

		if (!response.ok) {
			throw new Error(`API call failed: ${response.status}`);
		}

		const result = await response.json();

		return result;
	};
